module.exports = __webpack_public_path__ + "img/ck-ranking-upavatar.a594c148.png";